
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-curation",
      function () {
        return require("private-next-pages/our-curation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-curation"])
      });
    }
  